<script>
import PointBlockingModal from './PointBlockingModal.vue'

export default {
    name: 'SysTermProfileBlockingModal',
    extends: PointBlockingModal
}
</script>
